import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollProgress } from "@/components/ScrollProgress";
import { CookieBanner } from "@/components/CookieBanner";

export const PageShell = ({ children, testId }) => (
  <div className="min-h-screen bg-[#FAF9F6]" data-testid={testId}>
    <ScrollProgress />
    <Navbar />
    <div className="pt-32 sm:pt-36">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-10">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#6B5E62] di-underline"
          data-testid="page-back-home"
        >
          <ArrowLeft size={14} /> Home
        </Link>
      </div>
      <main>{children}</main>
    </div>
    <Footer />
    <CookieBanner />
  </div>
);
